import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { Logout } from '../../store/auth/auth.actions';
import { SnackBarService } from '../services/snack-bar/snack-bar.service';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const snackBar = inject(SnackBarService);
  const store = inject(Store);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        store.dispatch(new Logout());
        router
          .navigate(['/auth/login'])
          .then(() => snackBar.info('Deine Sitzung ist abgelaufen. Du musst dich erneut anmelden.', 10000));
      }
      return throwError(() => error);
    }),
  );
};
